// hnb-frontend/src/components/public/PublicHeader.tsx

import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import HnbLogo from '../brand/HnbLogo';
import { useAuth } from '../../hooks/useAuth';
import { getPostLoginRoute } from '../../auth/AuthProvider';

const navItems = [
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/find-provider', label: 'Find Provider' },
  { to: '/ai-plans', label: 'AI Plans' },
  { to: '/provider-plans', label: 'Provider Plans' },
  { to: '/downloads', label: 'Downloads' },
  { to: '/contact', label: 'Contact' },
];

const linkBaseStyle: React.CSSProperties = {
  textDecoration: 'none',
  color: '#334155',
  fontSize: '0.95rem',
  fontWeight: 500,
};

const authButtonBaseStyle: React.CSSProperties = {
  fontWeight: 600,
  fontSize: '0.95rem',
  borderRadius: 999,
  cursor: 'pointer',
};

export default function PublicHeader() {
  const { user, logout } = useAuth();

  // Debug: inspect the current auth user/session
  console.log('Auth user in header:', user);

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid #e5e7eb',
      }}
    >
      <div
        style={{
          maxWidth: 1400,
          margin: '0 auto',
          padding: '0.9rem 1.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '1rem',
          flexWrap: 'wrap',
        }}
      >
        <Link
          to="/"
          style={{
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
          }}
          aria-label="Go to home page"
        >
          <HnbLogo imageHeight={80} />
        </Link>

        <nav
          aria-label="Primary"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            flexWrap: 'wrap',
          }}
        >
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              style={({ isActive }) => ({
                ...linkBaseStyle,
                color: isActive ? '#111827' : '#475569',
                fontWeight: isActive ? 700 : 500,
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flexWrap: 'wrap',
          }}
        >
          {user ? (
            <>
              <Link
                to={getPostLoginRoute(user)}
                style={{
                  ...authButtonBaseStyle,
                  textDecoration: 'none',
                  color: '#0f172a',
                  background: '#ffffff',
                  border: '1px solid #dbe3ee',
                  padding: '0.7rem 1rem',
                }}
              >
                Dashboard
              </Link>

              <span
                style={{
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: '0.92rem',
                  whiteSpace: 'nowrap',
                }}
              >
                {user.name}
              </span>

              <button
                type="button"
                onClick={logout}
                style={{
                  ...authButtonBaseStyle,
                  color: '#0f172a',
                  background: '#ffffff',
                  border: '1px solid #dbe3ee',
                  padding: '0.7rem 1rem',
                }}
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                style={{
                  ...authButtonBaseStyle,
                  textDecoration: 'none',
                  color: '#0f172a',
                }}
              >
                Customer login
              </Link>

              <Link
                to="/provider/login"
                style={{
                  ...authButtonBaseStyle,
                  textDecoration: 'none',
                  color: '#0f172a',
                }}
              >
                Provider login
              </Link>

              <Link
                to="/staff/login"
                style={{
                  ...authButtonBaseStyle,
                  textDecoration: 'none',
                  color: '#0f172a',
                }}
              >
                Staff login
              </Link>
            </>
          )}

          <Link
            to="/find-provider"
            style={{
              textDecoration: 'none',
              background: '#111827',
              color: '#ffffff',
              padding: '0.7rem 1rem',
              borderRadius: 999,
              fontWeight: 600,
              fontSize: '0.95rem',
              boxShadow: '0 10px 22px rgba(15, 23, 42, 0.16)',
            }}
          >
            Book now
          </Link>
        </div>
      </div>
    </header>
  );
}